import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './Inputfield.css'
import classNames from 'classnames'

@CSSModules(styles, { allowMultiple: true })
export class Inputfield extends Component {
  constructor(props) {
    super(props)
    this.state = {
      updateTimer: null
    }
  }

  focus () {
    this.refs.input.focus()
  }

  render () {
    const { autoFocus, errorMessage, label, inputClasses, onBlur, onChange, offset, onFocus, onKeyPress, placeholder, type, value, maxLength, marginRight, size, small, grow, min, max } = this.props
    const inputFieldContainerClasses = classNames('inputFieldContainer', {
      grow: grow,
      small: small,
      'margin-right': marginRight,
      number: type === 'number'
    })
    const inputFieldClasses = inputClasses ? 'inputField ' + inputClasses : 'inputField'
    return (      
      <div
        style={{
          left: offset ? offset : 0
        }}
        styleName={inputFieldContainerClasses}>
        {label && <label styleName="label">{label}</label>}
        <div style={{ position: 'relative' }}>
          <div styleName={errorMessage === '' ? 'no-error' : 'has-error' + ' error'}>
            <div />
            <span>{errorMessage}</span>
          </div>        
          <input
            autoFocus={autoFocus}
            max={max}
            maxLength={maxLength}
            min={min}
            onBlur={onBlur}
            onChange={onChange}
            onFocus={onFocus}
            onKeyPress={onKeyPress}
            placeholder={placeholder}
            ref="input"
            size={size}
            styleName={inputFieldClasses}
            type={type}
            value={value} />
            {this.props.children}
          </div>
      </div>
    )
  }
}

Inputfield.propTypes = {
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  errorMessage: PropTypes.string,
  grow: PropTypes.bool,
  inputClasses: PropTypes.string,
  label: PropTypes.string,
  marginRight: PropTypes.bool,
  max: PropTypes.string,
  maxLength: PropTypes.number,
  min: PropTypes.string,
  offset: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.number,
  small: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string
}

Inputfield.defaultProps = {
  type: 'text',
  errorMessage: ''
}

export default Inputfield



// WEBPACK FOOTER //
// ./src/components/Inputfield/Inputfield.js